module.exports = __webpack_public_path__ + "static/assets/57e8961a64163e11b723414129e75693.png";